import { render } from "./CatalogHeader.vue?vue&type=template&id=91c5b074&scoped=true"
import script from "./CatalogHeader.vue?vue&type=script&lang=js"
export * from "./CatalogHeader.vue?vue&type=script&lang=js"

import "./CatalogHeader.vue?vue&type=style&index=0&id=91c5b074&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91c5b074"]])

export default __exports__